export enum MediaStatus {
	PENDING = 'pending',
	READY = 'ready'
}
